// @ts-nocheck
import { useState } from 'react';
import { YStack, XStack, Text, Input } from 'tamagui';

const WAITLIST_URL = 'https://waitlist-worker.romans-dev.workers.dev/api/waitlist';

interface WaitlistFormProps {
  product?: string;
  source: string;
  accent?: string;
  buttonText?: string;
}

export function WaitlistForm({ product = 'general', source, accent = '#a03030', buttonText = 'Join Waitlist' }: WaitlistFormProps) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  // Honeypot field — hidden from users, bots fill it
  const [website, setWebsite] = useState('');

  const handleSubmit = async () => {
    if (!email || !email.includes('@')) {
      setStatus('error');
      setMessage('Please enter a valid email.');
      return;
    }

    setStatus('loading');
    try {
      const res = await fetch(WAITLIST_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          product,
          source,
          newsletter: true,
          ...(website ? { website } : {}),
        }),
      });
      const data = await res.json();
      if (data.success) {
        setStatus('success');
        setMessage(data.message || "You're on the list!");
        setEmail('');
      } else {
        setStatus('error');
        setMessage(data.message || 'Something went wrong.');
      }
    } catch {
      setStatus('error');
      setMessage('Network error. Please try again.');
    }
  };

  if (status === 'success') {
    return (
      <YStack
        padding="$4"
        borderRadius="$3"
        borderWidth={1}
        borderColor={accent}
        style={{ borderColor: `${accent}40` }}
        alignItems="center"
        gap="$2"
      >
        <Text fontSize="$4" fontWeight="600" color={accent}>✓</Text>
        <Text fontSize="$3" color="$color10">{message}</Text>
      </YStack>
    );
  }

  return (
    <YStack gap="$3">
      <XStack flexDirection="row" gap="$2" flexWrap="wrap">
        <Input
          flex={1}
          minWidth={220}
          size="$4"
          placeholder="you@company.com"
          backgroundColor="$color2"
          borderColor="$color5"
          borderWidth={1}
          borderRadius="$3"
          color="$color12"
          placeholderTextColor="$color7"
          value={email}
          onChangeText={setEmail}
          onSubmitEditing={handleSubmit}
        />
        <Text
          fontSize="$3"
          fontWeight="600"
          color="$color1"
          backgroundColor={accent}
          paddingHorizontal="$4"
          paddingVertical="$3"
          borderRadius="$3"
          cursor="pointer"
          hoverStyle={{ opacity: 0.9 }}
          onPress={handleSubmit}
          opacity={status === 'loading' ? 0.6 : 1}
          userSelect="none"
        >
          {status === 'loading' ? 'Sending...' : buttonText}
        </Text>
      </XStack>
      {/* Honeypot — hidden from users */}
      <input
        type="text"
        name="website"
        value={website}
        onChange={(e) => setWebsite(e.target.value)}
        style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0 }}
        tabIndex={-1}
        autoComplete="off"
      />
      {status === 'error' && (
        <Text fontSize="$2" color="$red9">{message}</Text>
      )}
      <Text fontSize="$1" color="$color6">No spam. Unsubscribe anytime.</Text>
    </YStack>
  );
}
